// Disable eslint for this file
/* eslint-disable complexity */

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote'],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{'script': 'sub'}, {'script': 'super'}],
  [{'indent': '-1'}, {'indent': '+1'}],
  [{'direction': 'rtl'}],
  [{'header': [1, 2, 3, 4, 5, 6, false]}],
  [{'color': []}, {'background': []}],
  [{'font': []}],
  [{'align': []}],
  ['clean'],
]

const quillSettings = {
  modules: {
    toolbar: toolbarOptions,
  },
  theme: 'snow',
}

const init = () => {
  if (document.querySelector('#quillEditorDiv')) {
    const quill = new Quill('#quillEditorDiv', quillSettings)

    quill.on('text-change', () => {
      const templateText = document.getElementById('statement_of_work_template_template')

      if (templateText) {
        templateText.value = quill.root.innerHTML
      }
    })
  }
}

export default {
  mounted() {
    init()
  },
  updated() {
    init()
  },
}
